var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pop-confirm',_vm._b({attrs:{"type":"danger","confirm":_vm.onConfirm,"size":"small"}},'pop-confirm',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("删除")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }